<template>

    <div style="min-height:100vh">

        <div class="modal">
            <div class="modal-content ">
                <span class="close">&times;</span>
                <ul class="edt">
                    
                    <li class="date">
                        <span>Lundi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="lundi-ouverture">Ouverture</label>
                        <input type="time" id="lundi-ouverture">
                        <label for="lundi-fermeture">Fermeture</label>
                        <input type="time" id="lundi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="lundi-ouverture-s">Ouverture</label>
                        <input type="time" id="lundi-ouverture-s">
                        <label for="lundi-fermeture-s">Fermeture</label>
                        <input type="time" id="lundi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Mardi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="mardi-ouverture">Ouverture</label>
                        <input type="time" id="mardi-ouverture">
                        <label for="mardi-fermeture">Fermeture</label>
                        <input type="time" id="mardi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="mardi-ouverture-s">Ouverture</label>
                        <input type="time" id="mardi-ouverture-s">
                        <label for="mardi-fermeture-s">Fermeture</label>
                        <input type="time" id="mardi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Mercredi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="mercredi-ouverture">Ouverture</label>
                        <input type="time" id="mercredi-ouverture">
                        <label for="mercredi-fermeture">Fermeture</label>
                        <input type="time" id="mercredi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="mercredi-ouverture-s">Ouverture</label>
                        <input type="time" id="mercredi-ouverture-s">
                        <label for="mercredi-fermeture-s">Fermeture</label>
                        <input type="time" id="mercredi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Jeudi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="jeudi-ouverture">Ouverture</label>
                        <input type="time" id="jeudi-ouverture">
                        <label for="jeudi-fermeture">Fermeture</label>
                        <input type="time" id="jeudi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="jeudi-ouverture-s">Ouverture</label>
                        <input type="time" id="jeudi-ouverture-s">
                        <label for="jeudi-fermeture-s">Fermeture</label>
                        <input type="time" id="jeudi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Vendredi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="vendredi-ouverture">Ouverture</label>
                        <input type="time" id="vendredi-ouverture">
                        <label for="vendredi-fermeture">Fermeture</label>
                        <input type="time" id="vendredi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="vendredi-ouverture-s">Ouverture</label>
                        <input type="time" id="vendredi-ouverture-s">
                        <label for="vendredi-fermeture-s">Fermeture</label>
                        <input type="time" id="vendredi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Samedi</span>
                        <span class="date-spec">Matin : </span>
                        <label for="samedi-ouverture">Ouverture</label>
                        <input type="time" id="samedi-ouverture">
                        <label for="samedi-fermeture">Fermeture</label>
                        <input type="time" id="samedi-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="samedi-ouverture-s">Ouverture</label>
                        <input type="time" id="samedi-ouverture-s">
                        <label for="samedi-fermeture-s">Fermeture</label>
                        <input type="time" id="samedi-fermeture-s">
                    </li>
                    <li class="date">
                        <span>Dimanche</span>
                        <span class="date-spec">Matin : </span>
                        <label for="dimanche-ouverture">Ouverture</label>
                        <input type="time" id="dimanche-ouverture">
                        <label for="dimanche-fermeture">Fermeture</label>
                        <input type="time" id="dimanche-fermeture">
                        <span class="date-spec">Soir : </span>
                        <label for="dimanche-ouverture-s">Ouverture</label>
                        <input type="time" id="dimanche-ouverture-s">
                        <label for="dimanche-fermeture-s">Fermeture</label>
                        <input type="time" id="dimanche-fermeture-s">
                    </li>
                    
        
                    
                </ul>
                <div class="button-1" id="horaire" v-on:click="RegisterJSON">Enregistrer les horaires</div>
            </div>
        </div>
        <ul class="menus">
        
        <li class="menu">
            <div class="menu-title">MUSÉES</div>
            <div class="menu-options">
                <ul class="menu-list">
                    <li class="menu-option">
                        
                            <input class="form-control" id="collection-musee" placeholder="Collection" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="titre-musee" placeholder="Titre" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="description-musee" placeholder="Description" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <label for="fileinput">Selectionner une image :</label>
                            <input type="file" id="fileinput" name="fileinput" class="file-input">
                            <img src="" alt="Bonsoir toi qui regarde mon code" id="imageholder"  class="invisible">

                            
                    </li>
                    <li class="menu-option">
                        
                            <div class="button-1" v-on:click="AddMusee">+ Add</div>
                    </li>
                    
                </ul>
            </div>
        </li>
        <li class="menu">
            <div class="menu-title">RESTAURANTS</div>
            <div class="menu-options">
                <ul class="menu-list">
                    <li class="menu-option">
                        
                            <input class="form-control" id="titre-restaurant" placeholder="Nom du restaurant" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="cuisine" placeholder="Type de cuisine" type="text">
                            
                    </li>
                    
                    <li class="menu-option">
                        
                            <input class="form-control" id="web" placeholder="Site internet" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="adresse" placeholder="Adresse" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="telephone" placeholder="Numéro de téléphone" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="score" placeholder="Note sur 5" min="0" max="5" type="number">
                            
                    </li>
                    <li class="menu-option">
                        
                            <button class="button-1" id="edt" v-on:click="OpenModal" > Horaires </button>
                            
                    </li>
                    <li class="menu-option">
                        
                            <label for="fileinput">Selectionner une image :</label>
                            <input type="file" id="fileinput2" class="file-input">
                            <img src="" alt="Bonsoir toi qui regarde mon code" id="imageholder2"  class="invisible">

                            
                    </li>
                    <li class="menu-option">
                        
                            <div class="button-1" v-on:click="AddRestaurant" >+ Add</div>
                    </li>
                    
                </ul>
            </div>
        </li>
        <li class="menu">
            <div class="menu-title">APPARTEMENTS</div>
            <div class="menu-options">
                <ul class="menu-list">
                    <li class="menu-option">
                        
                        <select class="form-control" id="exampleFormControlSelect1">
                            <option default>Logis des Clos</option>
                            <option>Logis du Chateau</option>
                            
                        </select>
                                                    
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="piece-appartement" placeholder="Nom de la piece" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <label for="fileinput">Selectionner une image (360 degrés) :</label>
                            <input type="file" id="fileinput2" class="file-input">
                            <img src="" alt="Bonsoir toi qui regarde mon code" id="imageholder2"  class="invisible">

                            
                    </li>
                    <li class="menu-option">
                        
                            <div class="button-1" v-on:click="AddRestaurant" >+ Add</div>
                    </li>
                    
                </ul>
            </div>
        </li>
        <li class="menu">
            <div class="menu-title">RANDONNÉES</div>
            <div class="menu-options">  
                <ul class="menu-list">
                    <li class="menu-option">
                        
                            <input class="form-control" id="titre-randonnee" placeholder="Titre" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="description-randonnee" placeholder="Description" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="url-randonnee" placeholder="Visorando Url" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="distance-randonnee" placeholder="Distance (km)" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <input class="form-control" id="denivele-randonnee" placeholder="Dénivelé (m)" type="text">
                            
                    </li>
                    <li class="menu-option">
                        
                            <div class="d-flex flex-row mx-auto">
                                <label for="easy-randonnee" class="my-auto">Facile</label>
                                <input  id="easy-randonnee" class="my-auto mx-1" type="checkbox" value="Facile">
                                <label for="normal-randonnee" class="my-auto">Moyen</label>
                                <input  id="normal-randonnee" class="my-auto mx-1" type="checkbox" value="Normale">
                                <label for="hard-randonnee" class="my-auto">Difficile</label>
                                <input  id="hard-randonnee" class="my-auto mx-1" type="checkbox" value="Difficile">
                            </div>
                            

                    </li>
                    <li class="menu-option">
                        
                            <label for="fileinput1">Selectionner un fichier GEOJSON :</label>
                            <input type="file" id="fileinput1" class="file-input">
                            
                    </li>
                    <li class="menu-option">
                        
                            <div class="button-1" v-on:click="AddRandonnee">+ Add</div>
                    </li>
                    
                </ul>
            </div>
        </li>
    </ul>
    </div>

    
</template>

<script>
export default {
    name: 'Admin',
    beforeCreate: function() {
        document.body.className = 'admin';
    },
    data : function() {
        return {
            imgFile : null,
            geojson : null,
            horaires : null,
            restaurantImg : null,
            rando_difficulty : null,
        } 
    },
    methods : {

        

        OpenModal : function(){
            const modal = document.getElementsByClassName('modal')[0];
            modal.style.display = 'block'
        }
        ,

        RegisterJSON : function(){
            const lundi = {matin : {
                open : document.getElementById('lundi-ouverture').value,
                close : document.getElementById('lundi-fermeture').value,
            },
            soir : {
                open : document.getElementById('lundi-ouverture-s').value,
                close : document.getElementById('lundi-fermeture-s').value,
            }}

            
            const mardi = {matin : {
                open : document.getElementById('mardi-ouverture').value,
                close : document.getElementById('mardi-fermeture').value,
            },
            soir : {
                open : document.getElementById('mardi-ouverture-s').value,
                close : document.getElementById('mardi-fermeture-s').value,
            }}

            const mercredi = {matin : {
                open : document.getElementById('mercredi-ouverture').value,
                close : document.getElementById('mercredi-fermeture').value,
            },
            soir : {
                open : document.getElementById('mercredi-ouverture-s').value,
                close : document.getElementById('mercredi-fermeture-s').value,
            }}

            const jeudi = {matin : {
                open : document.getElementById('jeudi-ouverture').value,
                close : document.getElementById('jeudi-fermeture').value,
            },
            soir : {
                open : document.getElementById('jeudi-ouverture-s').value,
                close : document.getElementById('jeudi-fermeture-s').value,
            }}

            const vendredi = {matin : {
                open : document.getElementById('vendredi-ouverture').value,
                close : document.getElementById('vendredi-fermeture').value,
            },
            soir : {
                open : document.getElementById('vendredi-ouverture-s').value,
                close : document.getElementById('vendredi-fermeture-s').value,
            }}

            const samedi = {matin : {
                open : document.getElementById('samedi-ouverture').value,
                close : document.getElementById('samedi-fermeture').value,
            },
            soir : {
                open : document.getElementById('samedi-ouverture-s').value,
                close : document.getElementById('samedi-fermeture-s').value,
            }}

            const dimanche = {matin : {
                open : document.getElementById('dimanche-ouverture').value,
                close : document.getElementById('dimanche-fermeture').value,
            },
            soir : {
                open : document.getElementById('dimanche-ouverture-s').value,
                close : document.getElementById('dimanche-fermeture-s').value,
            }}

            const week = {
            lundi : lundi,
            mardi : mardi,
            mercredi : mercredi,
            jeudi : jeudi,
            vendredi : vendredi,
            samedi: samedi,
            dimanche : dimanche
            }
            this.horaires = week
            const modal = document.getElementsByClassName('modal')[0];
            modal.style.display = 'none';
            const edt = document.getElementById('edt').style.backgroundColor = 'green';



        },
        
        Registerfile : function(root, file){
            const storageRef = this.$storage.ref(root + '/' + file.name);
            return new Promise(function(resolve, reject) {
                let task = storageRef.put(file);
                console.log(task);
                task.on('state_changed',
                function progress(snapshot) { },
                function error(err) { reject(err); },
                function complete(){resolve(task)}
                
                )
            })
            .then(function(task) {
                return task.task.snapshot.ref.getDownloadURL();
                
            })
            
        },

        AddRestaurant : async function()
        {
            const file = this.restaurantImg
            const storage = this.$storage
            const store = this.$firestore

            const title = document.getElementById('titre-restaurant').value;
            const collection = title.replace(' ', '-');
            const web = document.getElementById('web').value;
            const adresse = document.getElementById('adresse').value;
            const tel = document.getElementById('telephone').value;
            const cuisine = document.getElementById('cuisine').value;
            const score = document.getElementById('score').value;
            const url = await  this.Registerfile('imgs', file);
            const horaires = this.horaires
            store.collection('restaurants').doc(collection).set({
                title : title,
                web : web,
                url_img : url,
                adresse : adresse,
                tel : tel,
                cuisine : cuisine,
                score : score,
                hours : horaires

            }).then(() => {
                console.log('Files Uploaded')
            }).catch(function(error){
                console.log(error);
            });

        },

        AddMusee :async function()
        {   
            let collection = document.getElementById('collection-musee').value;
            let title = document.getElementById('titre-musee').value;
            let description = document.getElementById('description-musee').value;
            //envoi de l'image dans le stockage
            const file = this.imgFile
            const storage = this.$storage
            const store = this.$firestore

            const url = await this.Registerfile('imgs', file);
            store.collection('musee').doc(collection).set({
                title : title,
                content : description,
                url_img : url 
            }).catch(function(error){
                console.log(error);
            });

            /*this.$firestore.collection('musee').doc(collection).set({
                title : title,
                content : description,
                url_img : url_img 
            }).then(() => {
                collection = "";
                title = "";
                description = "";
                url_img = "";
                console.log('data written')
            }).catch((error) =>{
                console.log(error);
            });*/
            
        },
        AddRandonnee :async function()
        {
            
            let title = document.getElementById('titre-randonnee').value;
            let description = document.getElementById('description-randonnee').value;
            let distance = document.getElementById('distance-randonnee').value;
            let visorando = document.getElementById('url-randonnee').value;
            let denivele = document.getElementById('denivele-randonnee').value + 'm';
            const collection = title.replace(' ', '-')
            const difficulty = this.rando_difficulty;
            distance += "km"
            const file = this.geojson
            const storage = this.$storage
            const store = this.$firestore
            const url = await this.Registerfile('geojson',file);
            store.collection('randonnées').doc(collection).set({
                title : title,
                content : description,
                geojson : url,
                distance : distance,
                denivele : denivele,
                difficulty : difficulty,
                visorando_url : visorando
            }).then(()=> {
                console.log("File Uploaded")
            }).catch(function(error){
                console.log(error);
            });
        }
    },
    mounted() {

        //listener for checkbox
        const easy = document.getElementById('easy-randonnee');
        const normal = document.getElementById('normal-randonnee');
        const hard = document.getElementById('hard-randonnee');
        const instance = this;

        easy.addEventListener('click', function(){listenercheckbox(this)})
        normal.addEventListener('click', function(){listenercheckbox(this)})
        hard.addEventListener('click', function(){listenercheckbox(this)})
        
        //normal.addEventListener('change', listenercheckbox)
        //hard.addEventListener('change', listenercheckbox)

        const listenercheckbox = function(om)
        {
       
            easy.checked = false;
            normal.checked = false;
            hard.checked = false;
            om.checked = true;
            instance.rando_difficulty = om.value
            
            
            
        }


        const listener = function()
        {
            let reader = new FileReader();
            reader.onload = function(){
                imageholder.setAttribute('class', 'visible');
                imageholder.src = reader.result;
                this.imgFile = fileinput.files[0]
            }.bind(this);
            reader.readAsDataURL(fileinput.files[0]);
        }


        const listener2 = function()
        {
            let reader = new FileReader();
            reader.onload = function(){
                imageholder2.setAttribute('class', 'visible');
                imageholder2.src = reader.result;
                this.restaurantImg = fileinput2.files[0]
            }.bind(this);
            reader.readAsDataURL(fileinput2.files[0]);
        }

        const listener1 = function()
        {
            let reader = new FileReader();
            reader.onload = function(){
                this.geojson = fileinput1.files[0]
                
            }.bind(this);
            reader.readAsDataURL(fileinput1.files[0]);
        }
        //listeners image musee
        const fileinput = document.getElementById("fileinput");
        const fileinput1 = document.getElementById("fileinput1");
        const fileinput2 = document.getElementById("fileinput2");
        const imageholder = document.getElementById("imageholder");
        const imageholder2 = document.getElementById("imageholder2");
        fileinput.addEventListener('change', listener.bind(this) )
        fileinput1.addEventListener('change', listener1.bind(this) )
        fileinput2.addEventListener('change', listener2.bind(this) )

    }
    
}
</script>


<style scoped>

body{
    background-color: #f0f0f0;
}

ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
}



img {
    width: 100%;
}




.close {
    text-align: end;
    width: 100%;
}

.edt {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-bottom: 2rem;
}

.date-spec {
    text-align: left;
    font-size: 0.75rem;
    margin: 0.5rem;
}

.vl {
    border: 1px solid gray;
}

.button-1{
    background-color: #03A9F4;
    cursor: pointer;
    border-color: none;
    color: white;
    border-radius: 0.10rem;
    border-width:0px ;
    padding: 0.8rem;
    flex-shrink: 0;
    margin-left: 0.2rem;
    transition-duration: 0.2s;
}

.modal {
    background-color: black;
    background-color: rgba(0,0,0,0.28);
}

.modal-content {
    margin : 3rem auto;
    width: 80%!important;
    border: none!important;
    height: 80vh;
    padding: 0.5rem;
    overflow-y: auto!important;
}

.date {
    display: flex;
    flex-direction: column;
    padding: 0.25rem;
    margin-bottom: 0.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    border: 1px solid gray;
}




.button-1:hover{
     background-color: steelblue;
}

.menu-list{
    display: flex;
    flex-direction: column;
}

.form-control
{
    margin-top: auto;
    margin-bottom: auto;
}

.file-input{
    padding: 1rem;
    background-color: darkseagreen;
    height: 5rem;
}

.menu-option {
    width: 100%;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column!important;
}

.menus {
    width: 100%;
    display: flex;
    padding: 0.5rem;
    justify-content: space-around;
    flex-wrap: wrap;
}

.menu-options {
    display: flex;
    flex-direction: column;
    
}

.menu {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    flex-direction: column;
    background-color:lightblue!important;
    display: flex;
    padding: 1rem;
    margin-bottom: 3rem;
    width: 90%;
    
}

@media(min-width: 40rem)
{
    .menu
    {
        width: 50%!important;
    }
}
@media(min-width: 56rem)
{
    .menu
    {
        width: 31%!important;
    }
}

.menu-option {
    display: flex;
    flex-direction: row;

}
</style>